import React, { FC } from "react";
import { Button, Icon } from "@telia/teddy";
import _isEmpty from "lodash/isEmpty";
import _size from "lodash/size";
import { FORM_ID } from "../../../../../constants";
import { Form, ICartItem } from "../../../../../models";
import MemberForm from "../../components/organisms/MemberForm/MemberForm";
import TEXT from "../../text-consts";

interface Props {
    activeSubscription: string;
    campaignId?: string;
    draftSubscriptions: ICartItem[];
    isBarringsUsed: boolean;
    isCampaignAllowed: boolean;
    isCampaignToggled: boolean;
    isCatalogListingOk: boolean;
    isEmailTakenForTeliaSky?: boolean;
    isEmailTakenForTeliaTrygg?: boolean;
    isFetchingData: boolean;
    isNavigating: boolean;
    isOptingOutForTeliaXServices?: boolean;
    isProductUserAgeOk: boolean;
    isProductUserChild: boolean;
    isProductUserDifferentThanLegalOwner: boolean;
    isProductUserYoung: boolean;
    isSubscriptionDraft: boolean;
    memberForm: Form;
    onSubmitMemberDetails: () => void;
    postCode: string;
    setPersonalDetailsValue: (key: string, value: string | string[] | boolean) => void;
    shouldSubmitOrder?: boolean;
}

const ExpandedMemberCard: FC<Props> = ({
    setPersonalDetailsValue,
    activeSubscription,
    memberForm,
    postCode,
    campaignId,
    isCatalogListingOk,
    isBarringsUsed,
    isCampaignToggled,
    isCampaignAllowed,
    isProductUserAgeOk,
    isProductUserDifferentThanLegalOwner,
    isProductUserChild,
    isProductUserYoung,
    onSubmitMemberDetails,
    draftSubscriptions,
    isFetchingData,
    isNavigating,
    isSubscriptionDraft,
    isEmailTakenForTeliaTrygg,
    isEmailTakenForTeliaSky,
    isOptingOutForTeliaXServices,
    shouldSubmitOrder,
}) => {
    const isFinalMember = _size(draftSubscriptions) === 1 && isSubscriptionDraft;
    const finalMemberText = shouldSubmitOrder
        ? TEXT.ADD_MEMBER.FINAL_USER_SUBMIT_ORDER
        : TEXT.ADD_MEMBER.FINAL_USER_BUTTON;

    return (
        <div data-cy="expanded-member-card">
            <MemberForm
                selectedSubscriptionId={activeSubscription}
                memberForm={memberForm}
                isPostCodeFilled={_isEmpty(postCode)}
                campaignId={campaignId}
                isCatalogListingOk={isCatalogListingOk}
                isBarringsUsed={isBarringsUsed}
                isCampaignToggled={isCampaignToggled}
                isCampaignAllowed={isCampaignAllowed}
                isEmailTakenForTeliaTrygg={isEmailTakenForTeliaTrygg}
                isEmailTakenForTeliaSky={isEmailTakenForTeliaSky}
                isOptingOutForTeliaXServices={isOptingOutForTeliaXServices}
                isProductUserAgeOk={isProductUserAgeOk}
                isProductUserDifferentThanLegalOwner={isProductUserDifferentThanLegalOwner}
                isProductUserChild={isProductUserChild}
                isProductUserYoung={isProductUserYoung}
                setPersonalDetailsValue={setPersonalDetailsValue}
                onSubmitMemberDetails={onSubmitMemberDetails}
            />
            <div className="add-member__next-user add-member__step-button-container" data-cy="next-user">
                {/* These two are shown when filling out users first time */}
                {isSubscriptionDraft && !isFinalMember && (
                    <Button disabled={isFetchingData || isNavigating} type="submit" form={FORM_ID.ADD_MEMBER}>
                        {TEXT.ADD_MEMBER.NEXT_USER_BUTTON}
                        <Icon name="parental-guide" aria-hidden="true" focusable="false" />
                    </Button>
                )}
                {isFinalMember && (
                    <div className="add-member__step-button-container">
                        <Button
                            className="add-member__step-button"
                            disabled={isFetchingData || isNavigating}
                            type="submit"
                            loading={isFetchingData}
                            form={FORM_ID.ADD_MEMBER}
                        >
                            {finalMemberText}
                        </Button>
                    </div>
                )}
                {/* This btn is shown after 'Rediger' has been pressed on already filled out member */}
                {!isSubscriptionDraft && (
                    <div className="add-member__step-button-container">
                        <Button disabled={isFetchingData || isNavigating} type="submit" form={FORM_ID.ADD_MEMBER}>
                            <Icon name="checkmark" aria-hidden="true" focusable="false" />
                            Lagre
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExpandedMemberCard;
